export default __webpack_public_path__ + "static/media/partydeco-logo.158958db.png";